export default __webpack_public_path__ + "static/media/product_engagement_report.47d73b54.png";